import { render, staticRenderFns } from "./BaseNps.vue?vue&type=template&id=566b980e&scoped=true&"
import script from "./BaseNps.vue?vue&type=script&lang=js&"
export * from "./BaseNps.vue?vue&type=script&lang=js&"
import style0 from "./BaseNps.vue?vue&type=style&index=0&id=566b980e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566b980e",
  null
  
)

export default component.exports